import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

import { NavBar } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { isFeishu } from '@/utils/feishu'
import { isApp } from '@/utils/client'
import { isWechatFlag } from '@/utils/weixin'
import { isTudoApp } from '@/utils/tudo'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isBranchManagerApp } from '@/utils/sandsTalkBranchManager'

interface IProps {
  titleConfig?: {
    title?: string
    leftText?: string
    leftArrow?: boolean
    fixed?: boolean
    selfClick?: boolean
  }
  showTitle?: boolean
  feishuShow?: boolean
  weixinShow?: boolean
  tudoShow?: boolean
  wisdomRabbitApp?: boolean
  sandsTalkNative?: boolean
  sandsTalkPhOutfieldApp?: boolean
  branchManagerApp?: boolean
  sandsTalkMsFlutterApp?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    titleConfig: { default: () => {
    return {
      title: '',
      leftText: '',
      leftArrow: true,
      fixed: false,
      selfClick: false
    }
  } },
    showTitle: { type: Boolean, default: true },
    feishuShow: { type: Boolean, default: false },
    weixinShow: { type: Boolean, default: false },
    tudoShow: { type: Boolean, default: false },
    wisdomRabbitApp: { type: Boolean, default: false },
    sandsTalkNative: { type: Boolean },
    sandsTalkPhOutfieldApp: { type: Boolean },
    branchManagerApp: { type: Boolean },
    sandsTalkMsFlutterApp: { type: Boolean }
  },
  emits: ["goBack", "rightClick"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter()
const route = useRoute()



const emit = __emit

const meta = route.meta

const onClickLeft = (selfClick: boolean) => {
  if (!selfClick) {
    router.go(-1)
  }
  emit('goBack')
}
const onClickRight = () => {
  emit('rightClick')
}

return (_ctx: any,_cache: any) => {
  return (
      (!_unref(isFeishu) || _ctx.feishuShow) &&
      !_unref(isApp) &&
      (!_unref(isWechatFlag) || _ctx.weixinShow) &&
      (!_unref(isTudoApp) || _ctx.tudoShow) &&
      (!_unref(isSandsTalkFlutterApp) || _ctx.sandsTalkNative) &&
      (!_unref(isSandsTalkPhOutfieldApp) || _ctx.sandsTalkPhOutfieldApp) &&
      (!_unref(isWisdomRabbitApp) || _ctx.wisdomRabbitApp) &&
      (!_unref(isBranchManagerApp) || _ctx.branchManagerApp) &&
      (!_unref(isSandsTalkMSFlutterApp) || _ctx.sandsTalkMsFlutterApp)
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(NavBar), {
          title: _ctx.titleConfig.title,
          fixed: _ctx.titleConfig.fixed,
          "left-text": _ctx.titleConfig.leftText,
          "left-arrow": _ctx.titleConfig.leftArrow !== false ? true : false,
          border: false,
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (onClickLeft(_ctx.titleConfig.selfClick))),
          onClickRight: onClickRight,
          "z-index": "500"
        }, {
          title: _withCtx(() => [
            (_ctx.showTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.titleConfig.title || _ctx.$t(`${_unref(meta).title}`)), 1))
              : _renderSlot(_ctx.$slots, "title", { key: 1 })
          ]),
          right: _withCtx(() => [
            _renderSlot(_ctx.$slots, "right")
          ]),
          _: 3
        }, 8, ["title", "fixed", "left-text", "left-arrow"])
      ]))
    : _createCommentVNode("", true)
}
}

})